import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Public
import HomePage from "@/pages/public/HomePage";
import IssuesArchivePage from "@/pages/public/IssuesArchivePage";
import IssueDetailPage from "@/pages/public/IssueDetailPage";
import AboutPage from "@/pages/public/AboutPage";
import ContactPage from "@/pages/public/ContactPage";
import PrivacyPage from "@/pages/public/PrivacyPage";
import TermsPage from "@/pages/public/TermsPage";
import NotFoundPage from "@/pages/public/NotFoundPage";
import ISentItPage from "@/pages/public/ISentItPage";
import SupportPage from "@/pages/public/SupportPage";
import { PublicThemeProvider } from "@/contexts/ThemeContext";

// Admin
import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminDashboardPage from "@/pages/admin/AdminDashboardPage";
import AdminIssuesListPage from "@/pages/admin/AdminIssuesListPage";
import AdminIssueEditorPage from "@/pages/admin/AdminIssueEditorPage";
import AdminSponsorsPage from "@/pages/admin/AdminSponsorsPage";
import AdminPromptsPage from "@/pages/admin/AdminPromptsPage";
import AdminSettingsPage from "@/pages/admin/AdminSettingsPage";
import AdminAuditLogPage from "@/pages/admin/AdminAuditLogPage";
import AdminAutomationPage from "@/pages/admin/AdminAutomationPage";
import { RequireAdmin } from "@/components/admin/RequireAdmin";

function App() {
  return (
    <div className="App">
      <PublicThemeProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            {/* Public */}
            <Route path="/" element={<HomePage />} />
            <Route path="/issues" element={<IssuesArchivePage />} />
            <Route path="/issues/:slug" element={<IssueDetailPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/i-sent-it" element={<ISentItPage />} />

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<RequireAdmin><AdminDashboardPage /></RequireAdmin>} />
            <Route path="/admin/issues" element={<RequireAdmin><AdminIssuesListPage /></RequireAdmin>} />
            <Route path="/admin/issues/new" element={<RequireAdmin><AdminIssuesListPage /></RequireAdmin>} />
            <Route path="/admin/issues/:id" element={<RequireAdmin><AdminIssueEditorPage /></RequireAdmin>} />
            <Route path="/admin/automation" element={<RequireAdmin><AdminAutomationPage /></RequireAdmin>} />
            <Route path="/admin/sponsors" element={<RequireAdmin><AdminSponsorsPage /></RequireAdmin>} />
            <Route path="/admin/prompts" element={<RequireAdmin><AdminPromptsPage /></RequireAdmin>} />
            <Route path="/admin/settings" element={<RequireAdmin><AdminSettingsPage /></RequireAdmin>} />
            <Route path="/admin/audit-log" element={<RequireAdmin><AdminAuditLogPage /></RequireAdmin>} />

            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
      </PublicThemeProvider>
    </div>
  );
}

export default App;
